
import React , {useEffect , useState } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css";
import shweta from '../assets/DocImages/madhuri.jpeg'
import pavanSir from "../assets/DocImages/Pavan.jpeg"
import shape from "../assets/Images/shapes/SHAPE 001-01.png"
import BookAppointmentDialog from './BookAnAppointmentDialogue'
export default function HomeOnSite () {
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true, 
    });
  }, []);
  return (
    <div className=' py-[64px] md:py-[240px] relative'>
      <div className='max-w-[1340px] mx-auto px-[24px] md:px-[24px] xl:px-[0px]'>
        <div
          className='flex flex-col xl:flex-row relative z-[1]'
        >
          
          <div className=' lg:mb-8 xl:mb-0 xl:max-w-[448px]' data-aos="fade-up" data-aos-delay="300">
            <h2 className='text-[36px] md:text-[58px] leading-[1.138em] font-heading text-thickGreen mb-[12px]'>
            Flexible healthcare options to choose from - Direct or Virtual mode
            </h2>
            <p className='text-[20px] font-[500] text-paraGreen leading-[1.667em] font-body mb-[40px]'>
            Get personalized care at your convenience. Choose either to visit our hospital remotely or in-person without compromising over the quality. 
            </p>
            <button
               onClick={handleOpenDialog}
              className='bg-orange text-white px-20 md:px-6 py-4 md:py-6 rounded-full font-medium   font-body text-[20px] leading-[1.112em] 
                transition-all duration-300 hover:bg-lightGreen hover:border-none hover:text-white hover:bg-opacity-90 
                hover:translate-y-[-3px] '
            >
              Book an Appointment
            </button>
          </div>

          <div className=' flex flex-col md:flex-row gap-10 lg:mt-0 md:mt-28 ' data-aos="fade-up" >
         
            <div className=' overflow-hidden mt-14 rounded-[24px]  h-[500px] md:mt-0 w-full  md:w-1/2'>
              <img
                src={shweta}
                alt='best Diabetologist in hyderabad' 
                className='w-full object-cover rounded-[24px]'
              />
            </div>

            
            <div className='rounded-[24px] overflow-hidden w-full md:w-1/2  h-[500px]  xl:mt-40'>
              <img
                src={pavanSir}
                alt='best doctor in hyderabad'
                className='w-full h-full object-cover'
              />
            </div>
          </div>
        </div>
        <div className='absolute top-[37%] lg:top-[37%] xl:top-[16%] left-[34%] inline-block z-[-1]'>
          <img
            src={shape}
            loading='lazy'
            alt='Virtual Line Right Shape Bg - Medic X Webflow Template'
            className='w-full h-auto animate__animated animate__fadeIn animate__delay-1s'
          />
        </div>
      </div>
      <BookAppointmentDialog open={dialogOpen} onClose={handleCloseDialog} />
    </div>
  )
}
          